import HttpMethod from '../../app/enums/HttpMethod';
import Practitioner from '../../app/models/Practitioner';
import { onClick, ready } from '../../app/support/utils';
import { currentLocalizedRoute, isProduction, localizedRoute, render336x280Ad, subscriptionBadge, __t } from '../../app/support/helpers';

ready(() => {
    onClick('#alpha li a', (e: Event) => {
        e.preventDefault();

        const target = e.target as HTMLElement;
        const letter = target.dataset.letter;
        const item   = target.closest('li');

        $.ajax({
            url: localizedRoute(window.app.currentRouteName, { keyword: letter }),
            type: HttpMethod.GET,
            dataType: 'json',
            beforeSend: () => {
                showLoader();
            }
        })
        .done((response: []) => {
            const practitioners = Practitioner.new(response);

            document.querySelectorAll('#alpha li').forEach((li) => {
                li.classList.remove('selected-letter');
            });

            item.classList.add('selected-letter');

            document.querySelector('.result-search-content')
                .innerHTML = renderPractitionersList(practitioners);
        })
        .fail((response) => {})
        .always(() => {
            hideLoader();
        });
    });

    /**
     * Show loader
     *
     * @return void
     */
    function showLoader() {
        document.querySelector('.bar-loader').classList.remove('hidden');
    }

    /**
     * Hide loader
     *
     * @return void
     */
    function hideLoader() {
        document.querySelector('.bar-loader').classList.add('hidden');
    }

    /**
     * Render practitioners list
     *
     * @param {Practitioner[]} practitioners
     * @returns {string}
     */
    function renderPractitionersList(practitioners: Practitioner[]): string {
        if (!practitioners.length) {
            return `
                <div class="col-sm-6 col-md-3 col-xs-12 margin_bottom_30 padding_0">
                    <p>${ __t("Pas de docteurs dans cette catégorie") }</p>
                </div>
            `;
        }

        return practitioners.map((practitioner, index) => {
            if (index % 10 === 0 && isProduction()) {
                return render336x280Ad();
            }
            return renderPractitionerItem(practitioner);
        }).join('');
    }

    /**
     * Render practitioner item
     *
     * @param {Practitioner} practitioner
     * @returns {string}
     */
    function renderPractitionerItem(practitioner: Practitioner): string {
        const practitionerFullName = currentLocalizedRoute('frontend.index.by_name')
            ? practitioner.prefixedReversedFullName()
            : practitioner.prefixedFullName();
        return `
            <div class="col-sm-6 col-md-3 col-xs-12 margin_bottom_30 padding_0">
                <a
                    class="extralight size_16 bleu2 label_radio pointer bold"
                    href="${ practitioner.showUrl() }">
                    <div class="profil-doc">
                        ${ practitionerFullName }
                        ${ practitioner.is_subscribed ? subscriptionBadge() : '' }
                    </div>
                </a>
                <label class="grry light width_100 size_13">
                    ${ practitioner.specialityName() }
                </label>
                <label class="grry light width_100 size_13">
                    ${ practitioner.cityName() }
                </label>
            </div>
        `;
    }
});
